// extracted by mini-css-extract-plugin
export var icon = "_57-1";
export var subtext = "_57-0";